import moduleIndex from '@/views/recognize/module/moduleIndex.vue'
export default {
  path: '/recognize',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    {
      path: 'moduleIndex',
      name: 'moduleIndex',
      component: moduleIndex
    }

  ]
}
